import React from 'react';
import { X } from 'lucide-react';

interface BetRemoveButtonProps {
  onRemove: () => void;
  label: string;
}

const BetRemoveButton: React.FC<BetRemoveButtonProps> = ({ onRemove, label }) => (
  <button
    onClick={onRemove}
    className="btn-remove ml-2 text-muted hover:text-danger"
    aria-label={`Remove ${label} bet`}
  >
    <X size={16} />
  </button>
);

export default BetRemoveButton;
